import _ from 'underscore';

export const getBidUtils = ({ i18n, pageContext }) => {
  if (!i18n || !pageContext) {
    return {};
  }
  const getText = (jsonValue, defaultText = '') => {
    if (_.isNull(jsonValue) || jsonValue.Amount < 0) {
      return defaultText;
    }
    const amount = i18n.formatDecimalToFixed(jsonValue.Amount);
    const addonText = _.result({
      '#Model.FixedBid': pageContext.AccountCurrencyCode,
      '#Model.PercentageBid': pageContext.DecimalFormatter.percentSymbol,
    }, jsonValue['@odata.type'], pageContext.AccountCurrencyCode);

    return [amount, addonText].join(' ');
  };

  return {
    bidUtils: {
      getText,
    },
  };
};
